import { FC, useState } from "react";
import {
  Box,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import { closeDrawer } from "actions/drawerActions";
import { useDispatch } from "react-redux";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { useStyles } from "../../../pages/DaAndFleets/styles";
import { DA_TABLE_HEADERS_COLUMN } from "pages/DaAndFleets/tableData";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { daUpdateTableSettings, resetDATableColumns } from "actions/daAndFleetActions";

interface DaTableSetitngsDrawerContentProps {}

export const DaTableSetitngsDrawerContent: FC<DaTableSetitngsDrawerContentProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    driverData: { driverListFilters },
  } = useTypeSelectors((state) => state.daAndFleets);

  const [activeCols, setActiveCols] = useState<string[]>(driverListFilters?.activeColumns || [])

  const closenModal = () => dispatch(closeDrawer());

  const handleFilterSubmit = () => {
    dispatch(daUpdateTableSettings({ activeColumns : activeCols}))
    closenModal()
  }

  const handleEditCols = (id: string) => {
    setActiveCols((prev) => prev.includes(id)
      ? prev.filter((item) => item !== id)
      : [...prev, id])
  }

  const handleReset = () => {
    closenModal()
    dispatch(resetDATableColumns())
  }

  return (
    <>
      <DialogContent className={classes.drawerContent}>
        {DA_TABLE_HEADERS_COLUMN.filter((col) => !["checkbox", "badge", "full_name"].includes(col.id)).map(
          (item) => (
            <FormControlLabel
              key={item?.id}
              onChange={() => handleEditCols(item?.id)}
              checked={activeCols.includes(item?.id)}
              control={<Checkbox />}
              label={<Typography style={{ marginRight: "10px" }}>{item?.label}</Typography>}
            />
          ),
        )}
      </DialogContent>
      <DialogActions className={classes.actionSection}>
        <Box className={classes.actionButtons}>
          <Box className={classes.actionButtonsLeft}>
            <CustomButton
              buttonText={"Save"}
              onClick={handleFilterSubmit}
              variant="contained"
              customClass={classes.drawerButton}
            />
            <CustomButton
              buttonText={"Cancel"}
              onClick={closenModal}
              variant="text"
              customClass={classes.drawerButton}
            />
          </Box>
          <CustomButton
            buttonText={"Reset"}
            onClick={handleReset}
            variant="text"
            customClass={classes.drawerButton}
          />
        </Box>
      </DialogActions>
    </>
  );
};
